import angular from "angular";

angular
	.module('app')
	.component('applicationShowForm', {
		template: require('./application-show-form.html'),
        controller: ['$http', controller],
        bindings: {
		    application: '<',
			user: '<'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
	};

	$ctrl.showAppCar = function (carIndex) {
		$ctrl.application.app_cars[carIndex].show = !$ctrl.application.app_cars[carIndex].show;
	};

	$ctrl.removeApp = () => {

	    if (!confirm('Вы точно хотите удалить заявку ?')) {
            $ctrl.loading = false;
            return;
        }

        const url = '/df/applications/' + $ctrl.application.id + '/destroy';

        $ctrl.loading = true;

        $http
            .post(url)
            .then(
                () => {
                    $ctrl.loading = false;

                    window.Swal.fire({
                        icon: 'success',
                        title: 'Заявка удалена',
                    }).then(() => {
                        window.location = '/df';
                    })
                },
                (error) => {
                    $ctrl.loading = false;

                    window.Swal.fire({
                        icon: 'error',
                        title: error.data.message,
                    });
                }
            );
    };
}
